module.exports = __webpack_public_path__ + "img/bvak.65493227.png";